export default __webpack_public_path__ + "static/media/storyboard-6.bba118b3.mp4";